import { render, staticRenderFns } from "./mine.vue?vue&type=template&id=2265f0f5&scoped=true"
import script from "./mine.vue?vue&type=script&lang=js"
export * from "./mine.vue?vue&type=script&lang=js"
import style0 from "./mine.vue?vue&type=style&index=0&id=2265f0f5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2265f0f5",
  null
  
)

export default component.exports